/* eslint-disable sonarjs/no-duplicate-string */
export default {
  quto: {
    acc: 'Quto',
    prep: 'Quto'
  },
  mail: {
    acc: 'Рамблер/почта',
    prep: 'Рамблер/почте'
  },
  news: {
    acc: 'Рамблер/новости',
    prep: 'Рамблер/новостях'
  },
  finance: {
    acc: 'Рамблер/финансы',
    prep: 'Рамблер/финансах'
  },
  realty: {
    acc: 'Рамблер/недвижимость',
    prep: 'Рамблер/недвижимости'
  },
  autorambler: {
    acc: 'Авторамблер',
    prep: 'Авторамблере'
  },
  travel: {
    acc: 'Рамблер/путешествия',
    prep: 'Рамблер/путешествиях'
  },
  video: {
    acc: 'Рамблер/видео',
    prep: 'Рамблер/видео'
  },
  audio: {
    acc: 'Рамблер/радио',
    prep: 'Рамблер/радио'
  },
  horoscopes: {
    acc: 'Рамблер/гороскопы',
    prep: 'Рамблер/гороскопах'
  },
  family: {
    acc: 'Рамблер/семья',
    prep: 'Рамблер/семье'
  },
  money: {
    acc: 'Рамблер/деньги',
    prep: 'Рамблер/деньгах'
  },
  soft: {
    acc: 'Рамблер/софт',
    prep: 'Рамблер/софт'
  },
  supermarket: {
    acc: 'Рамблер/маркет',
    prep: 'Рамблер/маркете'
  },
  r0: {
    acc: 'Рамблер/поиск',
    prep: 'Рамблер/поиске'
  },
  tv: {
    acc: 'Рамблер/тв-программа',
    prep: 'Рамблер/тв-программе'
  },
  weather: {
    acc: 'Рамблер/погода',
    prep: 'Рамблер/погоде'
  },
  top100: {
    acc: 'Рамблер/топ-100',
    prep: 'Рамблер/топ-100'
  },
  weekend: {
    acc: 'Субботний рамблер',
    prep: 'Субботнем рамблере'
  },
  love: {
    acc: 'Рамблер/знакомства',
    prep: 'Рамблер/знакомствах'
  },
  kassa: {
    acc: 'Рамблер/касса',
    prep: 'Рамблер/кассе'
  },
  id: {
    acc: 'Rambler&Co ID',
    prep: 'Rambler&Co ID'
  },
  news_media: {
    acc: 'Рамблер/новости',
    prep: 'Рамблер/новостях'
  },
  news2: {
    acc: 'Рамблер/новости',
    prep: 'Рамблер/новостях'
  },
  start: {
    acc: 'Рамблер/старт',
    prep: 'Рамблер/старте'
  },
  head: {
    acc: 'Рамблер/',
    prep: 'Рамблер/'
  },
  main: {
    acc: 'Рамблер/',
    prep: 'Рамблер/'
  },
  kino_media: {
    acc: 'Рамблер/кино',
    prep: 'Рамблер/кино'
  },
  auto_media: {
    acc: 'Авторамблер',
    prep: 'Авторамблере'
  },
  doctor_media: {
    acc: 'Рамблер/доктор',
    prep: 'Рамблер/докторе'
  },
  Afisha: {
    acc: 'Афиша',
    prep: 'Афише'
  },
  lenta: {
    acc: 'Lenta.ru',
    prep: 'Lenta.ru'
  },
  woman_media: {
    acc: 'Рамблер/женский',
    prep: 'Рамблер/женском'
  },
  help: {
    acc: 'Рамблер/помощь',
    prep: 'Рамблер/помощи'
  },
  class: {
    acc: 'Рамблер/класс',
    prep: 'Рамблер/классе'
  },
  comments: {
    acc: 'Рамблер/комментарии',
    prep: 'Рамблер/комментариях'
  },
  games: {
    acc: 'Рамблер/игры',
    prep: 'Рамблер/играх'
  },
  sport_media: {
    acc: 'Рамблер/спорт',
    prep: 'Рамблер/спорте'
  },
  champ: {
    acc: 'Чемпионат.com',
    prep: 'Чемпионат.com'
  }
}
